import groupsBlueSvg from '../../../assets/svg/Icons/32/groups-blue.svg';
import { groupTexts } from '../constants';

import ArchiveGroupCtrl from './ArchiveGroupCtrl';
import archiveUrl from './archive.html';

class ManageGroupCtrl {
  constructor(
    ConfirmService,
    Utils,
    Groups,
    PersonaCollection,
    Restangular,
    AlertService,
    UserUtils,
    $timeout,
    $state,
    $location,
    $sce,
    $uibModal,
    focus,
    uppercaseFirstFilter
  ) {
    'ngInject';

    Object.assign(this, {
      ConfirmService,
      Utils,
      Groups,
      PersonaCollection,
      Restangular,
      AlertService,
      UserUtils,
      $timeout,
      $state,
      $location,
      $sce,
      $uibModal,
      focus,
      uppercaseFirstFilter,
    });

    focus('focus');

    this.icon = groupsBlueSvg;

    this.users = PersonaCollection.users;
    this.previousState = '';
    this.tabs = [{ value: 'settings', label: 'settings' }];
  }

  $onInit() {
    this.nonDeletableMembers = this.nonDeletableMembers || [];

    if (this.group.id) {
      this.tabs.unshift({ value: 'employees', label: 'employees' });
    }

    if (!this.group.members) {
      this.group.members = [];
    }
    this.originalGroup = this.Restangular.copy(this.group);

    const initialTab = this.tabs.find((tab) => tab.value === this.tab);
    this.activeTab = initialTab ? initialTab.value : this.tabs[0].value;
  }

  formDisabled() {
    return this.form.$invalid;
  }

  delete() {
    const config = {
      question: `${groupTexts.defaultText} ${this.group.type}:`,
      warning: 'Warning: this cannot be undone.',
      title: `Delete ${this.group.type}`,
      conditions: [],
      confirm: 'Delete',
    };

    if (groupTexts[this.group.type]) {
      config.question = groupTexts[this.group.type].singleDeletion.title;
      config.conditions = groupTexts[this.group.type].singleDeletion.conditions;
      config.confirmText = groupTexts[this.group.type].singleDeletion?.confirmText;
    }

    this.ConfirmService.ask(config, () => {
      this.error = false;

      this.Restangular.all('groups')
        .customDELETE(null, { id: this.group.id })
        .then(
          () => this._deleteSuccess(),
          (error) => this._failure(error)
        );
    }).ignoreCancel();
  }

  async archive() {
    const params = await this.$uibModal.open({
      templateUrl: archiveUrl,
      controller: ArchiveGroupCtrl,
      controllerAs: 'ctrl',
      size: '620',
      resolve: {
        groups: () => [this.group],
      },
    }).result;

    await this.PersonaCollection.archiveGroups([this.group], params);
    this.$timeout(() => {
      this.AlertService.success(`${this.uppercaseFirstFilter(this.group.type)} archived`);
    });

    this._goBack();
  }

  _deleteSuccess() {
    this.$timeout(() => {
      this.AlertService.success(`${this.uppercaseFirstFilter(this.group.type)} deleted`);
    });

    this._goBack();
  }

  _successSave() {
    this.form.$setPristine();
  }

  _failure(error) {
    this.error = this.Utils.getErrorMessages(error);
  }

  _goBack() {
    const defaultRoute = `dashboard.manage.${this.group.type}s.list`;
    if (this.previousState) {
      const targetRoute = this.previousState.name || defaultRoute;
      const params = this.previousState.params || {};

      this.$state.go(targetRoute, params);
      return;
    }

    this.$state.go(defaultRoute);
    this.form.$setPristine();
  }

  async submit() {
    this.error = false;
    if (this.form.$invalid) {
      this.form.$setSubmitted();
      return;
    }

    await this.createAnyUsers?.();

    let promise;
    if (this.group.id) {
      promise = this.group.withHttpConfig().put();
      await promise;
      this._successSave();
      this.originalGroup = this.PersonaCollection.personasDict[this.group.id];
      this.originalGroup.hiddenOnSchedule = this.group.hiddenOnSchedule;
      this.cancel();
    } else {
      promise = this.Groups.withHttpConfig().post(this.group);
      await promise;
      this._goBack();
    }

    return promise;
  }

  cancel() {
    this.group = this.Restangular.copy(this.originalGroup);
    this.error = false;
    // we need to wait out setDirty inside persona picker
    this.$timeout(() => {
      this.form.$setPristine();
    });
  }

  changeTab(tabValue) {
    this.activeTab = tabValue;
    this.$location.search({ tab: this.activeTab });
  }

  isTabbedView() {
    return this.tabs.length > 1;
  }

  getInvalidTabs() {
    const invalidTabs = !this.form.$submitted
      ? []
      : this.tabs
          .filter((tab) => {
            const form = this[`${tab.value}Form`];
            return form && form.$invalid;
          })
          .map((tab) => tab.value);

    if (this.error && !invalidTabs.includes('settings')) {
      invalidTabs.push('settings');
    }

    return invalidTabs;
  }

  addAllMembers() {
    this.group.members = [...this.users];
  }

  clearAllMembers() {
    this.group.members = [];
  }
}

export default ManageGroupCtrl;
